<div id="team" class="team-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h4></h4>
            <h2>{{'teamTextOne' | translate}}<span></span></h2>
            <p></p>
        </div>
        <div class="team-slides">
            <owl-carousel-o [options]="teamSlides">
                <ng-template carouselSlide *ngFor="let casoSucesso of casosSucesso">
                    <div class="single-team-box">
                        <div class="image">
                            <img [src]="casoSucesso.imagem" alt="team-img">
                        </div>
                        <div class="content">
                            <h3 class="title">{{ casoSucesso.titulo }}</h3>
                            <span class="post">{{ casoSucesso.posto }}</span>
                        </div>
                        <div class="social">
                            <ul>
                                <li><a [href]="casoSucesso.link" target="_self" class="fa fa-eye"></a></li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
    <div class="shape1"><img src="assets/img/shape1.png" alt="image"></div>
</div>
